import React from "react";
import ReactDOM from "react-dom";
import NotloggedinModal from "./NotloggedinModal";
import window from "../WindowExtended";
import {useCustomerSelector} from "../../../store";

const ConnoxDealsModal: React.FC = () => {
  const {customer} = useCustomerSelector();
  const homepageRedirect = window.location.origin;
  const bodyElement = document.querySelector("body");
  const categoryId = bodyElement?.id;

  if (categoryId !== "C118994" || !bodyElement || customer.isLoggedIn) {
    return null;
  }

  const onCloseModal = () => {
    location.replace(homepageRedirect);
  };

  const onLoggedIn = () => {
    window.location.reload();
  };

  const divElement = document.createElement("div");
  bodyElement.appendChild(divElement);

  return ReactDOM.createPortal(
    <NotloggedinModal isVisible={true} closeFunction={onCloseModal} onLoggedIn={onLoggedIn} />,
    divElement,
  );
};

export default ConnoxDealsModal;
